jQuery($ => {

    if ($('.m-wide-product-cta-card')[0]) {
        if ($('.m-wide-product-cta-card__product-variation-button')[0]) {
            $('.m-wide-product-cta-card__product-variation-button').click(function () {
                var id = $(this).attr('id');

                $('.m-wide-product-cta-card__dropdown-item').removeClass('m-wide-product-cta-card__dropdown-item--active');

                $(".m-wide-product-cta-card__dropdown-item[data-variation-id='" + id + "']").addClass('m-wide-product-cta-card__dropdown-item--active');

            });
        }
    }
 
    if ($('.m-wide-product-cta-card--has-buy-direct-dropdown-option')[0]) {
        $('.m-wide-product-cta-card .m-logo-links-dropdown__item[aria-label="Buy Direct"]').mousedown(function () {
            $('.m-wide-product-cta-card__buy-direct').removeClass('m-wide-product-cta-card__buy-direct--hide');
        });
    }
}); 